import React from 'react';
import {COLORS, ExpansionHeader, ToggleIcon, Image, FONTS} from '@fupa/fupa-uikit';
import {bool, func, string} from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;

  > div {
    padding: 0 0.125rem;
  }

  & img {
    opacity: 0.6;
  }
`;

const Name = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const More = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background-color: ${COLORS.lighterGrey};
  color: ${COLORS.darkGrey};
  font-family: ${FONTS.Oswald};
  font-size: 0.5rem;
`;

const Emblems = ({teams}) => {
  const firstFourTeams = teams.map((team, index) => {
    if (index <= 3) {
      return <Image key={team.id} entity={'emblem'} width={20} height={20} fit={true} src={team.image} />;
    }
  });

  const moreButton = teams.length > 5 ? teams.length - 4 : null;
  let lastElement = null;
  if (moreButton) {
    lastElement = (
      <More>
        <span>+{moreButton}</span>
      </More>
    );
  }
  if (teams.length === 5) {
    lastElement = <Image entity={'emblem'} width={20} height={20} fit={true} src={teams[4].image} />;
  }

  return (
    <Container>
      {firstFourTeams}
      {lastElement}
    </Container>
  );
};

const GroupHeader = ({show, onClick, type, title, teams}) => {
  const name = type === 'cupgroup' ? 'Gruppe ' + title : title;
  const withEmblems = type === 'cupgroup' && teams.length;

  const emblems = withEmblems ? <Emblems teams={teams}>Hello</Emblems> : null;
  return (
    <ExpansionHeader onClick={onClick}>
      <ToggleIcon addmargin='right' open={show} style={{color: COLORS.darkGrey}} />
      <Name>{name}</Name>
      {emblems}
    </ExpansionHeader>
  );
};

GroupHeader.propTypes = {
  show: bool.isRequired,
  onClick: func.isRequired,
  type: string,
  title: string.isRequired,
};

GroupHeader.defaultProps = {
  type: 'none',
};

export default GroupHeader;
